import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Tab,
  Tabs
} from "react-bootstrap";
import { FiEyeOff } from "react-icons/fi";

export default function EditEmployeeModal({ show, onHide }) {

  const [tab, setTab] = useState("basic");
  const [image, setImage] = useState(null);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };


  return (
     <Modal show={show} onHide={onHide}  className="mt-2" size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>
     Edit Employee
          <span className="ms-2 text-muted fs-6">
           Employee ID : EMP -0024
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* TABS */}
        <Tabs activeKey={tab} onSelect={(k) => setTab(k)} className="mb-3">

          {/* BASIC INFO */}
          <Tab eventKey="basic" title="Basic Information">

            {/* IMAGE UPLOAD */}
            <div className="border rounded p-3 mb-3 bg-light text-center">
              <div className="mb-2">
                {image ? (
                  <img src={image} alt="preview" width="80" height="80" className="rounded-circle" />
                ) : (
                  <div className="border rounded-circle d-inline-block" style={{ width: 80, height: 80 }}></div>
                )}
              </div>

              <div>
                <Form.Label className="fw-semibold">
                  Upload Profile Image
                </Form.Label>
                <p className="text-muted small">Image should be below 4 mb</p>

                <Form.Control type="file" onChange={handleImage} />
              </div>
            </div>

            {/* FORM */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Employee ID *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Joining Date *</Form.Label>
                  <Form.Control type="date" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Username *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 position-relative">
                  <Form.Label>Password *</Form.Label>
                  <Form.Control type="password" />
                  <FiEyeOff className="position-absolute top-50 end-0 me-3" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 position-relative">
                  <Form.Label>Confirm Password *</Form.Label>
                  <Form.Control type="password" />
                  <FiEyeOff className="position-absolute top-50 end-0 me-3" />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Company *</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>

              {/* DROPDOWNS */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Department</Form.Label>
                  <Form.Select>
                    <option>All Departments</option>
                    <option>Developer</option>
                    <option>Executive</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Designation</Form.Label>
                  <Form.Select>
                    <option>All Designation</option>
                    <option>Developer</option>
                    <option>Executive</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label>About *</Form.Label>
                  <Form.Control as="textarea" rows={3} />
                </Form.Group>
              </Col>
            </Row>
          </Tab>

          {/* PERMISSIONS TAB */}
          <Tab   eventKey="permissions" title="Permissions">

            <div className="p-3 border rounded bg-light mb-3 d-flex justify-content-between">
              <strong>Enable Options</strong>
              <div>
                <Form.Check inline type="switch" label="Enable all Module" />
                <Form.Check inline type="checkbox" label="Select All" />
              </div>
            </div>

            {[
              "Holidays",
              "Leaves",
              "Clients",
              "Projects",
              "Tasks",
              "Chats",
              "Assets",
              "Timing Sheets"
            ].map((item, i) => (
              <div key={i}  className="permission-row d-flex align-items-center flex-wrap gap-3">

                <Form.Check type="switch" label={item} />

                {["Read", "Write", "Create", "Delete", "Import", "Export"].map((perm, j) => (
                  <Form.Check key={j} type="checkbox" label={perm} />
                ))}
              </div>
            ))}

          </Tab>

        </Tabs>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onHide={onHide}>
          Cancel
        </Button>
        <Button variant="primary">
          Save
        </Button>
      </Modal.Footer>
      <style>
          {
               `
               /* ============================= */
/* 🔶 GLOBAL ORANGE COLOR */
/* ============================= */
:root {
  --orange: #f26522;
}

/* ============================= */
/* 🔶 CHECKBOX */
/* ============================= */
.form-check-input:checked {
  background-color: var(--orange) !important;
  border-color: var(--orange) !important;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(242, 101, 34, 0.25) !important;
  border-color: var(--orange) !important;
}

/* 🔶 Active tab (Permissions or any selected tab) */
.nav-tabs .nav-link.active {
  color: #f26522 !important;        /* ORANGE TEXT */
  border-color: #dee2e6 #dee2e6 #fff;
  font-weight: 600;
}

/* 🔶 Optional: hover effect */
.nav-tabs .nav-link:hover {
  color: #f26522 !important;
}

/* 🔶 Optional: remove blue focus */
.nav-tabs .nav-link:focus {
  box-shadow: none !important;
}
/* ============================= */
/* 🔶 SWITCH (TOGGLE) */
/* ============================= */
.form-switch .form-check-input {
  width: 42px;
  height: 22px;
}

/* OFF state */
.form-switch .form-check-input {
  background-color: #ddd;
  border: none;
}

/* ON state (ORANGE) */
.form-switch .form-check-input:checked {
  background-color: var(--orange) !important;
}

/* remove default blue shadow */
.form-switch .form-check-input:focus {
  box-shadow: none !important;
}

/* ============================= */
/* 🔶 LABEL SPACING */
/* ============================= */
.form-check-label {
  margin-left: 5px;
}

/* ============================= */
/* 🔶 PERMISSION ROW DESIGN */
/* ============================= */
.permission-row {
  border: 1px solid #e5e5e5;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
  background: #fff;
}

/* ============================= */
/* 🔶 ENABLE OPTIONS BOX */
/* ============================= */
.enable-box {
  background: #f8f9fa;
  border: 1px solid #e5e5e5;
  padding: 12px;
  border-radius: 8px;
}`
          }
      </style>
    </Modal>
  );
}